import React from 'react'
import { viemaxImgUrls } from '../../../constants/viemax-constants'

const RecoveryJourney = () => {
  return (
    <section className="mt-[60px] px-2">
      <img
        src={viemaxImgUrls.recoveryJourney}
        alt="viemax-recovery-journey-image"
      />
    </section>
  )
}

export default RecoveryJourney
